import { Flex, FlexProps } from '@chakra-ui/react';

export const ResponsiveBox = ({ children, ...rest }: FlexProps) => {
  return (
    <Flex flexDir="column" w={{ base: '2xl', lg: '4xl', xl: '5xl' }} {...rest}>
      {children}
    </Flex>
  );
};
